export default `---
slug: exchange-oklahoma
type: extracurricular
dateRange: "Fall 2014 – Spring 2015"
institution: "High School, Ardmore Oklahoma"
location: "Ardmore, Oklahoma, USA"
role: "Exchange Student — AFS Program"
current: false
skills: [AP Biology, AP Mathematics, English Literature, Accounting, Latin]
relatedLinks:
  - label: "United States"
    href: /travel/usa
  - label: "Belize"
    href: /travel/belize
---

The fourth year of high school, from fall 2014 to spring 2015, I spent in the US — specifically in Ardmore, Oklahoma, as an AFS exchange student. From a career and education point of view, several things stand out. I took AP Biology, Math and English Literature, passing math with 5/5 and biology with 4/5. I failed the English Literature AP exam with a score of 2.5/5 — the passing grade was 3. In my defense, English was not my strongest language yet.

On top of the APs, during the year I participated in a few intra-school competitions in Oklahoma. I placed first in math in both competitions I entered, and I also placed first in Latin during the second competition. In the first competition I did accounting as my second subject, and placed in the top 10 despite having zero formal training in accounting. Those results felt pretty good for a kid who had been in the country for just a few months.
`;
